export default __webpack_public_path__ + "static/media/1-010.b97885da.jpg";